import * as React from 'react';
import { Input,Rating } from "@progress/kendo-react-inputs";
export const RatingCell = props => {
 
 
  const {
    dataItem
  } = props;
  const field = props.field || '';
  const dataValue = dataItem[field] === null ? '' : dataItem[field];
 
  return <td>
    <Rating style={{
      width: "100%"
    }} value={dataValue.toString()} max={15}  textField="text" disabled />
      </td>;
};